//
import { ModuleLayout } from "@/components/reusable_components/next"

//
import PurchaseOrderEditedCreateView from "@/views/Purchase/PchPurchaseOrderEdited/create"
import PurchaseOrderEditedListView from "@/views/Purchase/PchPurchaseOrderEdited/list"
import PurchaseOrderEditedUpdateView from "@/views/Purchase/PchPurchaseOrderEdited/update"

//
export default {
    path: "purchase_orders_edited",
    component: ModuleLayout,
    children: [
        {
            path: "",
            name: "purchase-order-edited-list",
            component: PurchaseOrderEditedListView,
        },
        {
            path: "create",
            name: "purchase-order-edited-create",
            component: PurchaseOrderEditedCreateView,
            meta: {
                title: "Editar orden de compra"
            },
        },
        {
            path: ":id",
            name: "purchase-order-edited-update",
            component: PurchaseOrderEditedUpdateView,
            meta: {
                title: "Detalle de edición de orden de compra"
            },
        },
    ],
    meta: {
        title: "Ordenes de compra editadas",
    }
}